define('viewmodels/modals/dialogs/QuestInfoDialog',['underscore', 'knockout'], function (_, ko) {

    var tabMap = [
        { id: 'questPath', contentField: 'challengeTabName' },
        { id: 'leaders', contentField: 'leadersTabName' },
        { id: 'prizes', contentField: 'prizesTabName' }
    ];

    var QuestInfoDialog = function(dialog, session, quests, leaderboards, preselectedTabId) {
        var self = this;

        self.player = session.getAssociatedPlayer;
        var adventure = ko.deferredComputed(function() {
            return self.player().adventurer.getAdventure();
        });

        self.dialog = dialog;
        self.availableQuests = quests.availableQuests;
        self.currentQuest = adventure.property('currentQuest');
        self.currentObjective = adventure.property('currentObjective');
        self.currentCampaignContent = quests.currentCampaignContent;
        self.leaderboardEntries = leaderboards.getEntriesById(self.currentQuest);

        self.isCompleted = function(objective, index) {
            return ko.deferredComputed(function() {
                var currentObjectiveIndex = self.currentQuest().getCurrentObjectiveIndex();
                return objective.isVisiblyCompleted(index, currentObjectiveIndex)();
            });
        };

        self.tabs = _.map(tabMap, function(tab) {
            return {
                id: tab.id,
                title: self.currentCampaignContent.property(tab.contentField)
            };
        });

        self.selectedTabId = ko.observable(preselectedTabId ? preselectedTabId : _.first(tabMap).id);
    };

    QuestInfoDialog.prototype.selectTab = function(id) {
        if (this.selectedTabId() === id) {
            return;
        }
        this.selectedTabId(id);
    };

    QuestInfoDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return QuestInfoDialog;
});

